import * as Yup from 'yup';
import { LanguagesType } from 'App/i18n';

export const buildValidationSchema = (
  languages: LanguagesType[],
): Yup.AnyObjectSchema =>
  Yup.object().shape({
    name: Yup.object().shape({
      ...languages.reduce(
        (acc, current) => ({
          ...acc,
          [current]: Yup.string()
            .trim()
            .required('businessDataPage.update.errorName'),
        }),
        {},
      ),
    }),
    orderTaxesEnabled: Yup.boolean(),
    orderTaxesPercent: Yup.string()
      .trim()
      .test(
        'maxPercentage',
        'businessDataPage.generalInformationCard.errors.orderTaxesPercent.valueMax',
        (_, { parent: { orderTaxesEnabled, orderTaxesPercent } }) =>
          (orderTaxesEnabled &&
            Number(orderTaxesPercent) >= 0 &&
            Number(orderTaxesPercent) <= 100) ||
          !orderTaxesEnabled,
      )
      .when('orderTaxesEnabled', {
        is: true,
        then: Yup.string().required(
          'businessDataPage.generalInformationCard.errors.orderTaxesPercent.required',
        ),
      }),
  });
